module.exports = __webpack_public_path__ + "img/soul-central.b9a2fb1b.png";